import { graphql } from 'react-relay';
export const CompanyHubAnnouncementBannerStatusQuery = graphql`
	query CompanyHubAnnouncementBannerStatusQuery($bannerId: String!) {
		adminAnnouncementBannerSetting(id: $bannerId) {
			id
			status
		}
	}
`;
